type WiFiEncryptionType = 'WPA' | 'WEP' | 'nopass'

interface WiFiBarcodeData {
    ssid: string
    password?: string
    encryption?: WiFiEncryptionType
    hidden?: boolean
}

const quoteIfHex = (x: string) =>
    [...x.toUpperCase()].every((c) => [...'ABCDEF1234567890'].includes(c))
        ? `"${x}"`
        : x

export const wifi = ({
    ssid,
    password,
    encryption = 'nopass',
    hidden,
}: WiFiBarcodeData) => {
    if (encryption === 'nopass') password = undefined
    if (!ssid) throw new Error('SSID is required')

    // leave out defaults to improve size
    return `WIFI:${[
        // nopass is the default
        encryption !== 'nopass' && `T:${encryption}`,
        password &&
            `P:${quoteIfHex(password.replace(/[\\;,":]/g, (c) => `\\${c}`))}`,
        `S:${quoteIfHex(ssid)}`,
        // false is default
        hidden && `H:true`,
    ]
        .filter(Boolean)
        .join(';')};;`
}
